/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { Log_Out_User } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import { check_Device } from "../../../Utils/find_device";
import { User, LogOut, Wrench } from "lucide-react";
import { BadgeInfo, HandHelping, Settings, MonitorCog } from "lucide-react";
import { io } from "socket.io-client";
import { base_url } from "../../../Utils/Config";
import Swal from "sweetalert2";
import { TRADING_OFF_USER } from "../../../ReduxStore/Slice/Users/DashboardSlice";


const DropDown = ({ avatar, onAvatarChange, userName }) => {
  // const socket = io(base_url);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [CheckUser] = useState(check_Device());
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Get user details from localStorage
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const user_details_goTo = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const user_role_goTo = JSON.parse(localStorage.getItem("user_role_goTo"));
  const user_role = JSON.parse(localStorage.getItem("user_role"));
  const landing_page_permission = JSON.parse(
    localStorage.getItem("landing_page_permission")
  );
  // const isTradingOn = localStorage.getItem("Trading_status")

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Toggle dropdown
  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  // Close dropdown and navigate
  const handleMenuClick = () => {
    setIsOpen(false);
  };



  // Logout user
  const LogoutUser = async () => {

    const isTradingOn =
      Number(localStorage.getItem("Trading_status") || 0) === 1;

    Swal.fire({
      title: "Are you sure?",
      text: isTradingOn
        ? "Your trading will also be turned OFF."
        : "You will be logged out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const userId = user_details?._id || user_details?.user_id;

        if (!userId) {
          toast.error("User ID missing");
          return;
        }
        if (isTradingOn) {
          const tradingRes = await dispatch(
            TRADING_OFF_USER({
              user_id: userId,
              device: "",
              network_ip: "",
            })
          ).unwrap();

          if (!tradingRes.status) {
            toast.error(tradingRes.msg || "Failed to turn OFF trading");
            return;
          }
        }

        // 🔵 2️⃣ Logout API → ALWAYS
        const logoutRes = await dispatch(
          Log_Out_User({
            userId: userId,
            Device: CheckUser,
          })
        ).unwrap();

        if (logoutRes.status) {
          localStorage.clear();
          navigate("/login");

          toast.success(
            isTradingOn
              ? "Logged out successfully. Trading turned OFF."
              : "Logged out successfully."
          );
        } else {
          toast.error("Logout failed");
        }
      } catch (error) {
        console.error("Logout error:", error);
        toast.error("Something went wrong");
      }
    });
  };




  // Profile routes mapping
  const profileRoutes = {
    USER: "/client/profile",
    ADMIN: "/admin/profile",
    SUBADMIN: "/subadmin/profile",
    SUPERADMIN: "/super/profile",
  };

  const getProfileRoute = () => {
    const roleKey = gotodashboard ? user_role_goTo : user_details?.Role;
    return profileRoutes[roleKey] || "/client/profile";
  };

  const displayName = gotodashboard
    ? user_details_goTo?.UserName
    : user_details?.UserName || "Guest";

  const showAdminOptions = user_details?.Role === "ADMIN" && !gotodashboard;
  const showUserOptions = user_details?.Role === "USER";

  useEffect(() => {
    if (!user_details?.user_id) return;

    const handleUserStatusUpdate = (data) => {
      if (data.status == 0 && data.userId === user_details.user_id) {
        LogoutUser();
      }
    };
    if (user_details.Role === "USER") {
      // socket.on("userStatusUpdate", handleUserStatusUpdate);

      // return () => {
      //   socket.off("userStatusUpdate", handleUserStatusUpdate);
      // };
    }
  }, [user_details?.user_id]);

  return (


    <div
      ref={dropdownRef}
      className="dropdown custom-dropdown  position-relative"
    >

      {/* Dropdown Trigger */}
      <button
        type="button"
        className="btn btn-sm d-flex align-items-center dropdown-toggle"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        style={{
          border: "none",
          background: "transparent",
          padding: "4px",
        }}
      >
        <img
          src={avatar || "../assets/avatar.jpg"}
          alt="Avatar"
          className="rounded-circle"
          style={{
            width: "40px",
            height: "40px",
            objectFit: "cover",
            border: "2px solid #e1e7ef",
            transition: "border-color 0.3s ease",
          }}
          onError={(e) => {
            e.target.src = "../assets/avatar.jpg";
          }}
        />
      </button>

      {/* Dropdown Menu */}
      <ul
        className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}
        style={{
          position: "absolute",
          top: "100%",
          right: "0",
          margin: "8px 0 0 0",
          padding: "8px 0",
          minWidth: "200px",
          maxWidth: "250px",
          backgroundColor: "var(--bs-dropdown-bg, #ffffff)",
          border: "1px solid var(--bs-border-color, #e1e7ef)",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          transform: isOpen ? "translateY(0)" : "translateY(-10px)",
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? "visible" : "hidden",
          transition: "all 0.2s ease-in-out",
        }}
      >
        {/* User Info Header */}
        <li className="dropdown-header text-center px-3 py-2">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <i className="fas fa-user me-2 text-primary" />
            <span className="text-capitalize fw-semibold">{displayName}</span>
          </div>
          <hr className="my-2" style={{ margin: "0", opacity: "0.3" }} />
        </li>

        {/* Profile Link */}
        <li>
          <Link
            to={getProfileRoute()}
            className="dropdown-item d-flex align-items-center px-3 py-2"
            onClick={handleMenuClick}
            style={{
              transition: "background-color 0.2s ease",
              textDecoration: "none",
            }}
          >
            <User className="me-2" size={16} />
            <span>Profile</span>
          </Link>
        </li>

        {/* Admin Options */}
        {showAdminOptions && (
          <>
            <li>
              <Link
                to="/admin/system"
                className="dropdown-item d-flex align-items-center px-3 py-2"
                onClick={handleMenuClick}
                style={{
                  transition: "background-color 0.2s ease",
                  textDecoration: "none",
                }}
              >
                <MonitorCog className="me-2" size={16} />
                <span>System</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/helpcenter"
                className="dropdown-item d-flex align-items-center px-3 py-2"
                onClick={handleMenuClick}
                style={{
                  transition: "background-color 0.2s ease",
                  textDecoration: "none",
                }}
              >
                <HandHelping className="me-2" size={16} />
                <span>Help Center</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/faq"
                className="dropdown-item d-flex align-items-center px-3 py-2"
                onClick={handleMenuClick}
                style={{
                  transition: "background-color 0.2s ease",
                  textDecoration: "none",
                }}
              >
                <BadgeInfo className="me-2" size={16} />
                <span>FAQ</span>
              </Link>
            </li>
            <li>
              <Link
                to="/admin/settings"
                className="dropdown-item d-flex align-items-center px-3 py-2"
                onClick={handleMenuClick}
                style={{
                  transition: "background-color 0.2s ease",
                  textDecoration: "none",
                }}
              >
                <Settings className="me-2" size={16} />
                <span>Settings</span>
              </Link>
            </li>
          </>
        )}

        {/* User Trading Settings */}
        {user_details?.Role === "USER" && !gotodashboard && (
          <li>
            <Link
              to="/client/Setting"
              className="dropdown-item d-flex align-items-center px-3 py-2"
              onClick={handleMenuClick}
              style={{
                transition: "background-color 0.2s ease",
                textDecoration: "none",
              }}
            >
              <Settings className="me-2" size={16} />
              <span> Settings</span>
            </Link>
          </li>
        )}


        {landing_page_permission === 1 && user_role === "ADMIN" && (
          <li>
            {user_details?.type != 1 && user_role === "ADMIN" && (
              <Link
                to="/admin/landing_page_setting"
                className="dropdown-item d-flex align-items-center px-3 py-2"
                onClick={handleMenuClick}
                style={{
                  transition: "background-color 0.2s ease",
                  textDecoration: "none",
                }}
              >
                <Wrench className="me-2" size={16} />
                <span>Landing Page Settings</span>
              </Link>
            )}
          </li>
        )}



        {/* Logout */}
        {!gotodashboard && (
          <>
            <li>
              <button
                className="dropdown-item d-flex align-items-center px-3 py-2 w-100"
                onClick={() => {
                  handleMenuClick();
                  LogoutUser();
                }}
                style={{
                  border: "none",
                  background: "transparent",
                  transition: "background-color 0.2s ease",
                  color: "#dc3545",
                }}
              >
                <LogOut className="me-2" size={16} />
                <span>Logout</span>
              </button>
            </li>
          </>
        )}
      </ul>

      {/* Custom CSS for hover effects */}
      <style>{`
        .dropdown-item:hover {
          background-color: var(--bs-dropdown-link-hover-bg, #f8f9fa) !important;
          color: var(--bs-dropdown-link-hover-color, #1e2125) !important;
        }
        
        .dropdown-item:focus {
          background-color: var(--bs-dropdown-link-hover-bg, #f8f9fa) !important;
          outline: none;
        }

        .dropdown-item:active {
          background-color: var(--bs-dropdown-link-active-bg, #0d6efd) !important;
          color: var(--bs-dropdown-link-active-color, #ffffff) !important;
        }

        .dropdown-toggle::after {
          display: none !important;
        }

        @media (max-width: 768px) {
          .dropdown-menu {
            min-width: 180px !important;
            left: auto !important;
            right: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default DropDown;
